import { useState, useCallback, useEffect } from "react";
import { request } from "../../httpClient";

type TAdd = {
  id?: string | number;
  title?: string;
  description?: string;
  reciever?: string;
  manual?: boolean;
};

type TDelete = {
  id: string;
};

export const usePushList = () => {
  const [pushListLoading, setPushListLoading] = useState(false);
  const [pushList, setPushList] = useState([]);

  const getPushList = useCallback(async () => {
    setPushListLoading(true);
    const res = await request({
      path: "push/list",
    });
    setPushList(res?.data?.reverse());
    setPushListLoading(false);
    return res?.data;
  }, []);

  const pushDeleteReq = useCallback(async (params: TDelete) => {
    setPushListLoading(true);
    const res = await request({
      path: "push/delete",
      method: "POST",
      body: JSON.stringify(params),
    });
    setPushListLoading(false);
    await getPushList();
    return res?.data;
  }, []);

  const pushAddReq = useCallback(async (params: TAdd) => {
    setPushListLoading(true);
    const res = await request({
      path: "push/add",
      method: "POST",
      body: JSON.stringify(params),
    });
    setPushListLoading(false);
    await getPushList();
    return res?.data;
  }, []);

  useEffect(() => {
    getPushList();
  }, []);

  return { pushList, pushListLoading, getPushList, pushDeleteReq, pushAddReq };
};
